import { Track } from 'livekit-client';
/**
 * К <video>-элементу плитки привязывается только камера. Аудио участника играет
 * через отдельный элемент (см. remoteAudioPlayback), поэтому оно не должно
 * попадать сюда: иначе один и тот же микрофон звучал бы дважды, а при
 * размонтировании плитки звук пропадал бы вместе с картинкой.
 */
function getCurrentCameraPublications(participant) {
    return participant.getTrackPublications().filter((publication) => publication.source === Track.Source.Camera);
}
export function attachCurrentParticipantTracks(participant, videoElement) {
    getCurrentCameraPublications(participant).forEach((publication) => publication.track?.attach(videoElement));
}
export function detachCurrentParticipantTracks(participant, videoElement) {
    getCurrentCameraPublications(participant).forEach((publication) => publication.track?.detach(videoElement));
}
